/**
 * Shared visual tokens for dashboard widgets — one elegant, consistent card
 * language (soft hairline border, rounded-xl, subtle shadow + hover), used by
 * every widget so the dashboard reads as one system.
 */
export const CARD = 'rounded-xl border border-gray-200/80 bg-white shadow-sm';
export const CARD_PAD = `${CARD} p-4`;
export const CARD_HOVER = `${CARD} transition-shadow duration-200 hover:shadow-md`;

// Small muted section/kpi label.
export const LABEL = 'text-[11px] font-semibold uppercase tracking-wide text-gray-400';
// Card/section heading.
export const HEADING = 'text-sm font-semibold text-gray-800';

// Accent dot colors (subtle identity without heavy borders).
export const ACCENT_DOT = {
  blue: 'bg-blue-500',
  indigo: 'bg-indigo-500',
  teal: 'bg-teal-500',
  amber: 'bg-amber-500',
  red: 'bg-red-500',
  green: 'bg-green-500',
  purple: 'bg-purple-500',
  sky: 'bg-sky-500',
};
